import { resourceExplorerWidgetDataSelector } from "./resourceExplorerWidgetDataSelector";
import { RootState } from "../../../../store";

export const resourceExplorerWidgetTotalCostSelector = (state: RootState) => {
  const totalCost = resourceExplorerWidgetDataSelector(state)?.total_cost;

  return totalCost ? +totalCost.toFixed(2) : 0;
};
